<script setup lang="ts">

import {Attachment, EmailAddress, ReadedEmlJson} from 'eml-parse-js/dist/interface';
import moment from 'moment/moment';
import {base64ToBlob, humanFileSize, openBlob} from '@/util';
import Loading from '@/components/Loading.vue';
import {ref, watch} from 'vue';
import {getData} from '@/api/module/dms';
import {readEml} from 'eml-parse-js';
import {useStorage} from '@/composables/storage';
import useDetailContactHistoryEmailStore from '@/store/detailContactHistoryEmail';

const emailStore = useDetailContactHistoryEmailStore();

useStorage(
    emailStore,
    undefined,
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        KontaktNr: parseInt(Array.isArray(route.params.contact_history_id) ? route.params.contact_history_id[0] : route.params.contact_history_id),
        Id: parseInt(Array.isArray(route.params.email_id) ? route.params.email_id[0] : route.params.email_id),
      };
    },
);

const isLoading = ref(true);
const tab = ref<'content' | 'attachments' | 'recipients'>('content');
const attachments = ref<Attachment[]>([]);

const content = ref<string | undefined>(undefined);
const emlData = ref<ReadedEmlJson | undefined>(undefined);

async function downloadEml() {
  const data: Blob = await getData(emailStore.data[0].Datei.DownloadToken);
  try {
    readEml(await data.text(), (err, data) => {
      if (err) {
        throw new Error('email ging schief');
      }

      emlData.value = data;
      if (data?.html) {
        content.value = data?.html;
      } else {
        content.value = data?.text;
      }

      attachments.value = data?.attachments ?? [];
    });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

function recipients(input: EmailAddress | EmailAddress[] | null | undefined): EmailAddress[] {
  if (!input) return [] as EmailAddress[];

  return Array.isArray(input) ? input : [input];
}

function getDisplayNameFromEmailAddress(input: EmailAddress): string {
  return input.name != '' ? `${input.name} (${input.email})` : input.email;
}

async function openAttachment(attachment: Attachment) {
  const blob = base64ToBlob(attachment.data64, attachment.contentType);
  await openBlob(blob, attachment.name);
}

watch(() => emailStore.loading, (loaded) => {
  if (!loaded) {
    downloadEml();
  }
});
</script>

<template>
  <div v-if="!isLoading && emlData">
    <v-tabs
      v-model="tab"
      align-tabs="center"
      bg-color="primary"
      fixed-tabs
      class="position-sticky"
      style="top: 3rem; z-index: 2"
    >
      <v-tab value="content">Inhalt</v-tab>
      <v-tab value="recipients">Empfänger</v-tab>
      <v-tab value="attachments" :disabled="attachments.length == 0">Anhänge ({{ attachments.length }})</v-tab>
    </v-tabs>
    <v-window v-model="tab">
      <v-window-item value="content" class="pa-n2">
        <v-card :elevation="0">
          <v-card-text>{{ emlData.subject }}</v-card-text>
          <v-card-subtitle>An: {{ getDisplayNameFromEmailAddress(emlData.to as EmailAddress) }}</v-card-subtitle>
          <v-card-subtitle>Datum: {{ moment(emlData.date).format('DD.MM.YYYY HH:mm') }}</v-card-subtitle>
          <v-card-text>
            <div v-html="content"/>
          </v-card-text>
        </v-card>
      </v-window-item>
      <v-window-item value="recipients">
        <v-list v-if="emlData">
          <v-list-item v-for="recipient in recipients(emlData.to)" :key="recipient.email">
            <v-list-item-title>{{ recipient.email }}</v-list-item-title>
            <v-list-item-subtitle v-if="recipient.name != ''">{{ recipient.name }}</v-list-item-subtitle>
          </v-list-item>
          <v-list-item v-for="recipient in recipients(emlData.cc)" :key="recipient.email">
            <v-list-item-title>{{ recipient.email }}</v-list-item-title>
            <v-list-item-subtitle v-if="recipient.name != ''">{{ recipient.name }}</v-list-item-subtitle>
            <template v-slot:append>
              <v-badge content="CC" color="info" inline/>
            </template>
          </v-list-item>
        </v-list>
      </v-window-item>
      <v-window-item value="attachments">
        <v-list lines="two">
          <div v-for="attachment in attachments" :key="attachment.id">
            <v-list-item @click="openAttachment(attachment)">
              <v-list-item-title>{{ attachment.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ humanFileSize(attachment.data.length) }}</v-list-item-subtitle>
            </v-list-item>
            <v-divider/>
          </div>
        </v-list>
      </v-window-item>
    </v-window>
  </div>
  <loading v-else/>
</template>

<style scoped>

</style>
